import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Grade from "./Grade";

const LetterMark = ({ computeGrades,letterMarkList }) => {
  return (
    <div className="letter-mark">
      <h3>Letter Mark</h3>
      {letterMarkList.map((letterMark, index) => (
        <Grade computeGrades = {computeGrades} key={index} />
      ))}
    </div>
  );
};

LetterMark.propTypes = {};

export default LetterMark;
